<button
  pButton
  type="button"
  class="stripe-add-card-trigger-btn"
  icon="pi pi-credit-card"
  [label]="label"
  (click)="open()"
></button>

<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [closable]="!cardForm?.isSaving"
  [dismissableMask]="false"
  [style]="{ width: '440px' }"
  styleClass="stripe-add-card-dialog"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="stripe-add-card-dialog-header">
      <span class="stripe-add-card-dialog-icon"><i class="pi pi-credit-card"></i></span>
      <span class="stripe-add-card-dialog-title">Add card</span>
    </div>
  </ng-template>
  <app-stripe-add-card #cardForm (cardSaved)="onCardSaved($event)" (cancelled)="close()"></app-stripe-add-card>
</p-dialog>
